<template>
  <div>
    <div v-if="showMessage" @click="showMessage = false" class="z-20 fixed inset-0 w-full h-full cursor-pointer border">
      <div class="fixed w-full h-full opacity-25 bg-black"></div>
      <div class="flex items-center justify-center h-full">
        <div class="z-30 mx-10 px-12 py-5 bg-gray-200 border rounded-lg shadow-lg">
          <div class="lg:flex justify-between items-center">
            <div class="font-bold text-gray-900 mb-5 lg:mb-0">Merci, votre message a bien été envoyé !</div>
            <Check class="block px-1 py-1 lg:ml-3 text-teal-500 bg-teal-200 border-2 border-teal-300 rounded-full h-10" />
          </div>
        </div>
      </div>
    </div>

    <form action="http://formspree.io/raffin.charlotte@gmail.com" method="POST">
      <div class="container mx-auto py-10">
        <div class="sm:flex mt-5">
          <div class="sm:w-1/2 mt-5 sm:mt-0 sm:mr-5 mx-5">
            <input class="block px-5 py-4 rounded-lg w-full shadow-inner text-gray-700 border" type="text" name="name" placeholder="Votre nom">
          </div>

          <div class="sm:w-1/2 mt-5 sm:mt-0 sm:ml-5 mx-5">
            <input class="block px-5 py-4 rounded-lg w-full shadow-inner text-gray-700 border" name="_replyto" type="text" placeholder="Votre e-mail">
          </div>
        </div>

        <div class="mt-5 mx-5">
          <input class="block px-5 py-4 rounded-lg w-full shadow-inner text-gray-700 border" type="text" name="subject" placeholder="Votre sujet">
        </div>

        <div class="mt-5 mx-5">
          <textarea class="block px-5 py-4 rounded-lg w-full shadow-inner text-gray-700 border" name="message" placeholder="Votre message" rows="10"></textarea>
        </div>

        <div class="mt-5 mx-5 flex justify-start md:justify-end">
          <button @click="send" class="block px-16 py-2 rounded-lg bg-teal-400 text-teal-100 hover:text-white hover:shadow-lg shadow">Envoyer</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Check from '@/components/Check'

export default {
  components: {
    Check,
  },

  data() {
    return {
      showMessage: false,
    };
  },

  methods: {
    send() {
      this.showMessage = true;
    },

    clear() {
      this.name = "";
      this.mail = "";
      this.subject = "";
      this.message = "";
    },
  },
}
</script>
